package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.series.create_customer_card

import kotlinx.serialization.Serializable

@Serializable
class CreateCustomerCardModel {

}